import './Toggle.scss';

const Toggle = ({ value, onChange }) => {
    return (
        <>
            <input type="checkbox" id="switch" className="toggle-checkbox" value={value} onChange={({ target: { checked } }) => onChange(checked)} />
            <label for="switch" className={`toggle-label py-25 fs-200 lh-400 ff-inter-bold fw-bold ${value ? 'text-left pl-150 text-white' : 'text-right pr-150 text-bright-red'}`}>{value ? 'Yearly' : 'Monthly'}</label>
        </>
    )
};

export default Toggle;